import { useEffect, useState } from "react";
import GroupTitle from "./GroupTitle";
import { PaymentContractInformations } from "../../../common/types";
import { ContractTypes } from "../../../common/types/FirmContractTypes";
import { Button } from "../Elements";
import Modal from "../Modal";
import commonNetwork from "../../../common/api/commonNetwork";
import { FIRM_PATH } from "../../../constants/storageKeys";

type Props = {
    licenseKey: string,
    taxCode: string
}
const PaymentContractArea = (props: Props) => {


    const [isOpenContractModal, setIsOpenContractModal] = useState(false);
    const [contractText, setContractText] = useState("");
    const [firmContractList, setFirmContractList] = useState<Array<PaymentContractInformations>>();

    useEffect(() => {
        selectFirmContractList();
    }, []);

    const selectFirmContractList = async () => {

        const result = await commonNetwork.get(`/public/getAgrementByFirmPath?firmPath=${localStorage.getItem(FIRM_PATH)}`);

        if (result.isSuccess) {
            setFirmContractList(result.data);
        }
    }

    const openContractModal = (text: string) => {
        setContractText(text);
        setIsOpenContractModal(true);
    };

    const hideContractModal = () => setIsOpenContractModal(false);

    const getContractByType = (item: PaymentContractInformations) => {
        switch (item.contracttype) {
            case ContractTypes.contactForm:
                return {
                    label: "İletişim Bilgileri"
                }
            case ContractTypes.distanceSale:
                return {
                    label: "Mesafeli Satış Sözleşmesi"
                }
            case ContractTypes.kvkkContracts:
                return {
                    label: "KVKK Aydınlatma Metni"
                }
            case ContractTypes.refundTerms:
                return {
                    label: "İade Bilgileri"
                }
            case ContractTypes.securityInfo:
                return {
                    label: "Güvenlik Bilgileri"
                }
            case ContractTypes.serviceContracts:
                return {
                    label: "Hizmet Sözleşmesi"
                }
            default:
                break;
        }
    }

    const contractModal = () => {
        return (
            <Modal openModal={isOpenContractModal} setOpenModal={hideContractModal}
                dialogclassName={"!max-w-[1000px] min-h-[85vh] flex flex-col justify-between"}
            >
                <div dangerouslySetInnerHTML={{
                    __html: contractText
                }}>
                </div>
                <div className="mt-5 mt-4 flex justify-end space-x-2">
                    <Button
                        color="primary"
                        hover="primary"
                        size="xs"
                        callback={hideContractModal}
                    >
                        Kapat
                    </Button>
                </div>
            </Modal>
        );
    };

    return (
        <>
            <div className="w-full mt-6">
                <GroupTitle title="Sözleşmeler" />

                <div className="mb-4" />
                {firmContractList?.map((item, index) => item.contract && item.contract != "<p>&nbsp;</p>" ? (
                    <div key={"contract" + index} className="mb-1.5" >
                        <a className="underline cursor-pointer"
                            onClick={() => openContractModal(item.contract)} >
                            {getContractByType(item)?.label}
                        </a>
                    </div>
                ) : null)}
                <div className=" text-center flex justify-start mt-6">
                    <div className=" text-[#ADA7A7] text-sm">
                        Ödeme işlemine devam ederek sözleşmeleri okuduğumu ve anladığımı kabul ediyorum.
                    </div>
                </div>
            </div>

            {contractModal()}
        </>
    );
}
export default PaymentContractArea;